export type Lang = 'es' | 'en'

export const translations = {
  es: {
    nav: {
      cta: 'Empezar gratis',
    },
    hero: {
      headlineLine1: 'No respondas',
      headlineLine2: 'hasta leer esto.',
      p1Before: 'Porque si lo haces antes de entender qué hay ',
      p1Italic: 'realmente',
      p1After:
        ' detrás de ese mensaje, podrías arruinar algo que todavía tiene solución.',
      p2: 'Ya sabes de qué hablo.',
      p3: 'Ese mensaje que llevas releyendo desde esta mañana. El que tiene tres palabras de más o tres palabras de menos. El que suena normal pero algo en ti dice que no lo es.',
      p4: 'Lo copiaste. Lo analizaste. Se lo mandaste a tu mejor amigo. Y su respuesta no te convenció. Porque en el fondo sabes que nadie, ni siquiera ellos, puede leer lo que hay entre esas líneas.',
      untilNow: 'Hasta ahora.',
      cta: 'Descifra tu primer mensaje gratis',
    },
    problem: {
      h2Part1: 'La verdad que',
      h2Italic: 'nadie te dice',
      h2Part2: 'sobre los mensajes',
      intro: 'Cada vez que alguien te escribe, hay dos mensajes.',
      layer1Label: 'Capa 1',
      layer1Text: 'El que ves en la pantalla.',
      layer2Label: 'Capa 2',
      layer2Text: 'Y el que realmente quisieron decir.',
      p1: 'No es conspiración. No es paranoia. Es simplemente que las personas no siempre dicen exactamente lo que sienten. Usan palabras de relleno. Dejan espacios. Escogen cada palabra con más cuidado del que admitirían.',
      p2: 'Y tú lo sabes. Por eso no puedes dejar de releerlo.',
      p3: 'El problema no eres tú. El problema es que nadie te dio las herramientas para leer el código que está detrás del texto.',
    },
    failures: {
      h2Part1: 'Por qué lo que estás haciendo ahora',
      h2Italic: 'no funciona',
      items: [
        {
          title: 'Preguntarle a tus amigos',
          desc: 'Te dan su opinión basada en sus propias experiencias, sus propios miedos, su propia historia. No en la tuya.',
        },
        {
          title: 'Confiar en tu instinto',
          desc: 'Cuando estás emocionalmente involucrado, tu instinto está distorsionado. Tu cerebro ve lo que quiere ver, no lo que está ahí.',
        },
        {
          title: 'Esperar y ver',
          desc: 'Mientras esperas, el momento pasa. La ventana de respuesta perfecta se cierra. Y lo que podría haber sido una conversación real se convierte en silencio.',
        },
      ],
      closingBefore:
        'Ninguna de estas opciones te da lo que realmente necesitas: ',
      closingItalic: 'claridad.',
    },
    solution: {
      h2Part1: 'El momento en que',
      h2Italic: 'todo cambió',
      intro:
        'Imagina que pegas ese mensaje en una pantalla. Y en menos de 30 segundos ves:',
      bullets: [
        'El tono real detrás de las palabras',
        'La intención de quien lo escribió',
        'El nivel de interés real, no el que imaginas',
        '3 respuestas listas para elegir, según cómo quieres manejar la situación',
      ],
      noOpinions: 'No opiniones. No suposiciones. El código real del mensaje.',
      thisIs: 'Eso es exactamente lo que hace MyCodeEx.',
      whatIsTitle: 'Qué es MyCodeEx',
      whatIs1:
        'MyCodeEx es la primera app que descifra el código emocional detrás de cualquier mensaje de texto.',
      whatIs2:
        'No importa si es de tu ex que de repente apareció. De esa persona que te tiene con dudas. De tu jefe que escribió algo raro. De un amigo que no suena igual que antes.',
      whatIs3:
        'Pegas el mensaje. MyCodeEx lo analiza. Y en segundos tienes claridad total.',
      whatIs4:
        'Sin drama. Sin interpretaciones de amigos. Sin horas perdidas dándole vueltas.',
      howTitle: 'Cómo funciona',
      steps: [
        'Pegas el mensaje que te tiene confundido/a',
        'MyCodeEx analiza el tono, la intención y el contexto oculto',
        'Recibes el nivel de interés real y la intención detrás de las palabras',
        'Eliges entre 3 respuestas listas, diseñadas para tu situación específica',
      ],
      totalTime: 'Tiempo total: menos de 30 segundos.',
      disclaimer1: 'Esto no es terapia. No es consejo profesional.',
      disclaimer2: 'Es algo mejor para este momento específico.',
      disclaimer3:
        'Es una herramienta de claridad inmediata para cuando tu cabeza ya no puede procesar más sola.',
      disclaimer4:
        'MyCodeEx no te dice qué hacer con tu vida. Te dice qué hay detrás de ese mensaje. Y con esa información, tú decides.',
    },
    testimonials: {
      h2Part1: 'Lo que dicen quienes',
      h2Italic: 'ya lo usan',
      items: [
        {
          quote:
            'Llevaba dos horas intentando entender si estaba enojado o solo ocupado. MyCodeEx me lo dijo en 20 segundos y la respuesta que elegí funcionó.',
          author: 'Valeria M.',
          age: '24 años',
        },
        {
          quote:
            'Me sentía ridícula por no poder interpretar un mensaje de tres líneas. Ahora entiendo que no era yo. Era que necesitaba las herramientas correctas.',
          author: 'Andrea R.',
          age: '29 años',
        },
        {
          quote:
            'Lo usé con un mensaje de mi jefe que me tenía nervioso desde el lunes. Claridad total. Respondí con confianza.',
          author: 'Carlos T.',
          age: '31 años',
        },
      ],
    },
    pricing: {
      h2Part1: 'Lo que obtienes con',
      h2Italic: 'MyCodeEx Pro',
      benefits: [
        {
          title: 'Análisis ilimitados',
          desc: 'Sin límites cuando más lo necesitas',
        },
        {
          title: 'Tono + intención + nivel de interés',
          desc: 'Claridad completa en cada mensaje',
        },
        {
          title: '3 respuestas listas por análisis',
          desc: 'Nunca más te quedas sin saber qué decir',
        },
        {
          title: 'Historial de análisis',
          desc: 'Revisa patrones en conversaciones anteriores',
        },
        {
          title: 'Acceso inmediato desde cualquier dispositivo',
          desc: 'Disponible cuando el mensaje llega',
        },
      ],
      priceTitle: 'El precio',
      compare1Label: 'Terapia de pareja',
      compare1Price: '$150/hora',
      compare2Label: 'Consejo de amigos',
      compare2Price:
        'gratis pero inútil cuando estás emocionalmente involucrado',
      compare3Label: 'MyCodeEx Pro',
      compare3Price: '$4.99/mes',
      priceClosing:
        'Menos de lo que cuesta un café. Por claridad ilimitada en cada conversación que importa.',
      noRiskTitle: 'Sin riesgo. Sin compromiso.',
      noRisk1:
        'Empieza con 3 análisis completamente gratis. Sin tarjeta de crédito. Sin trucos.',
      noRisk2:
        'Si después de usarlo no sientes que cambia la forma en que lees tus conversaciones, simplemente no te suscribes.',
      noRisk3:
        'Pero si lo que sientes es lo que sienten miles de usuarios cada semana — esa sensación de "por fin entiendo qué está pasando" — entonces $4.99 al mes va a ser la decisión más fácil que tomes hoy.',
      finalTitle: 'Una última cosa antes de que cierres esta página',
      final1: 'Ese mensaje sigue ahí.',
      final2:
        'Y mientras más tiempo pases sin entender qué hay realmente detrás, más tiempo pasas tomando decisiones a ciegas.',
      final3: 'La claridad que necesitas está a 30 segundos de distancia.',
      finalItalic: 'Pega el mensaje. Lee el código. Responde con certeza.',
      finalCta: '▶ EMPIEZA GRATIS AHORA — 3 ANÁLISIS SIN COSTO',
      finalDisclaimer:
        'Sin tarjeta de crédito. Acceso inmediato. Cancela cuando quieras.',
    },
    faq: {
      title: 'Preguntas Frecuentes',
      items: [
        {
          q: '¿Es exacto?',
          a: 'MyCodeEx analiza patrones de lenguaje y tono. No adivina, descifra. Los resultados son tan útiles como el contexto que das.',
        },
        {
          q: '¿Es terapia o consejo profesional?',
          a: 'No. MyCodeEx es una herramienta de entretenimiento e interpretación de texto. Para situaciones que requieren apoyo profesional, siempre recomendamos buscar un especialista.',
        },
        {
          q: '¿Qué pasa si cancelo?',
          a: 'Cancelas cuando quieras, sin penalizaciones, desde tu perfil en segundos.',
        },
        {
          q: '¿Es seguro pegar mis conversaciones?',
          a: 'MyCodeEx no almacena ni comparte tus mensajes con terceros. Tu privacidad es prioridad.',
        },
        {
          q: '¿Para qué tipo de mensajes funciona?',
          a: 'Relaciones, trabajo, amigos, familia — cualquier mensaje de texto donde el tono o la intención no está clara.',
        },
      ],
    },
    footer: {
      copyright: 'Todos los derechos reservados.',
      tagline: 'Una herramienta de claridad inmediata.',
      privacy: 'Política de privacidad',
      terms: 'Términos y derechos',
    },
    privacyModal: {
      title: 'Política de privacidad',
      lastUpdated: 'Última actualización:',
      intro:
        'En MyCodeEx tu privacidad es prioridad. Esta política explica qué información recopilamos, cómo la usamos y qué control tienes sobre ella.',
      sections: [
        {
          h: '1. Qué recopilamos',
          p: 'Solo recopilamos la información mínima necesaria para que la app funcione: tu correo electrónico al crear una cuenta y los mensajes que tú decides pegar para analizar. No accedemos a tus conversaciones, contactos ni redes sociales.',
        },
        {
          h: '2. Qué hacemos con tus mensajes',
          p: 'Los mensajes que pegas se procesan únicamente para entregarte el análisis. No almacenamos ni compartimos tus mensajes con terceros con fines comerciales. El historial de análisis es visible solo para ti, en tu cuenta, y puedes borrarlo en cualquier momento.',
        },
        {
          h: '3. Cookies y analíticas',
          p: 'Usamos cookies esenciales para mantener tu sesión y herramientas de analítica anonimizada para entender cómo se usa la app. Nunca vendemos tus datos.',
        },
        {
          h: '4. Tus derechos',
          p: 'Puedes acceder, corregir o eliminar tu información cuando quieras escribiéndonos a privacidad@mycodeex.app. También puedes cancelar tu cuenta en segundos desde tu perfil.',
        },
        {
          h: '5. Cambios a esta política',
          p: 'Si actualizamos esta política, te avisaremos por correo o dentro de la app antes de que los cambios entren en vigor.',
        },
      ],
    },
    termsModal: {
      title: 'Términos y derechos',
      lastUpdated: 'Última actualización:',
      intro:
        'Al usar MyCodeEx aceptas los siguientes términos. Te recomendamos leerlos con calma — están escritos para que se entiendan.',
      sections: [
        {
          h: '1. Qué es MyCodeEx',
          p: 'MyCodeEx es una herramienta de entretenimiento e interpretación de texto. No es terapia, no es consejo legal ni profesional, y no sustituye el criterio de un especialista cuando una situación lo requiere.',
        },
        {
          h: '2. Uso responsable',
          p: 'Te comprometes a usar la app para mensajes propios o compartidos contigo de forma legítima. No uses MyCodeEx para acosar, espiar ni manipular a otras personas.',
        },
        {
          h: '3. Suscripción y pagos',
          p: 'MyCodeEx Pro cuesta $4.99/mes. Puedes cancelar cuando quieras desde tu perfil; el acceso continúa hasta el final del periodo ya pagado. Los primeros 3 análisis son gratis y no requieren tarjeta.',
        },
        {
          h: '4. Propiedad intelectual',
          p: 'El nombre MyCodeEx, el logo, el mecanismo Emotional Code Reading™, los textos, el diseño y el código de la app son propiedad de MyCodeEx y están protegidos por las leyes de derechos de autor y marca. No pueden copiarse ni redistribuirse sin permiso por escrito.',
        },
        {
          h: '5. Limitación de responsabilidad',
          p: 'Los análisis son sugerencias basadas en patrones de lenguaje. La decisión final de cómo responder, qué hacer o cómo interpretar una relación es tuya. MyCodeEx no se hace responsable de los resultados de las conversaciones o decisiones que tomes.',
        },
        {
          h: '6. Contacto',
          p: '¿Dudas, sugerencias o reclamos? Escríbenos a hola@mycodeex.app. Respondemos en menos de 48 horas.',
        },
      ],
    },
  },
  en: {
    nav: {
      cta: 'Start free',
    },
    hero: {
      headlineLine1: "Don't reply",
      headlineLine2: 'until you read this.',
      p1Before: "Because if you do before understanding what's ",
      p1Italic: 'really',
      p1After:
        ' behind that message, you could ruin something that still has a fix.',
      p2: "You know what I'm talking about.",
      p3: "That message you've been re-reading since this morning. The one with three extra words or three missing words. The one that sounds normal but something in you says it isn't.",
      p4: "You copied it. You analyzed it. You sent it to your best friend. And their answer didn't convince you. Because deep down you know that nobody — not even them — can read what's between those lines.",
      untilNow: 'Until now.',
      cta: 'Decode your first message free',
    },
    problem: {
      h2Part1: 'The truth',
      h2Italic: 'nobody tells you',
      h2Part2: 'about messages',
      intro: 'Every time someone texts you, there are two messages.',
      layer1Label: 'Layer 1',
      layer1Text: 'The one you see on the screen.',
      layer2Label: 'Layer 2',
      layer2Text: 'And the one they actually meant.',
      p1: "It's not a conspiracy. It's not paranoia. People simply don't always say exactly what they feel. They use filler words. They leave gaps. They choose each word with more care than they'd admit.",
      p2: "And you know it. That's why you can't stop re-reading it.",
      p3: "The problem isn't you. The problem is that nobody gave you the tools to read the code behind the text.",
    },
    failures: {
      h2Part1: "Why what you're doing right now",
      h2Italic: "isn't working",
      items: [
        {
          title: 'Asking your friends',
          desc: 'They give you their opinion based on their own experiences, their own fears, their own history. Not yours.',
        },
        {
          title: 'Trusting your gut',
          desc: "When you're emotionally involved, your gut is distorted. Your brain sees what it wants to see, not what's there.",
        },
        {
          title: 'Wait and see',
          desc: "While you wait, the moment passes. The perfect reply window closes. And what could've been a real conversation becomes silence.",
        },
      ],
      closingBefore: 'None of these gives you what you actually need: ',
      closingItalic: 'clarity.',
    },
    solution: {
      h2Part1: 'The moment',
      h2Italic: 'everything changed',
      intro:
        'Imagine pasting that message on a screen. And in less than 30 seconds you see:',
      bullets: [
        'The real tone behind the words',
        'The intent of the person who wrote it',
        "The real level of interest — not the one you're imagining",
        '3 ready-to-send replies to choose from, based on how you want to handle the situation',
      ],
      noOpinions: 'No opinions. No guesses. The real code behind the message.',
      thisIs: "That's exactly what MyCodeEx does.",
      whatIsTitle: 'What is MyCodeEx',
      whatIs1:
        'MyCodeEx is the first app that decodes the emotional code behind any text message.',
      whatIs2:
        "It doesn't matter if it's from your ex who suddenly reappeared. From that person who's been keeping you guessing. From your boss who wrote something weird. From a friend who doesn't sound the same anymore.",
      whatIs3:
        'You paste the message. MyCodeEx analyzes it. And in seconds you have total clarity.',
      whatIs4:
        "No drama. No friends' interpretations. No hours wasted overthinking.",
      howTitle: 'How it works',
      steps: [
        'Paste the message that has you confused',
        'MyCodeEx analyzes the tone, intent, and hidden context',
        'You get the real level of interest and the intent behind the words',
        'You choose between 3 ready replies, designed for your specific situation',
      ],
      totalTime: 'Total time: less than 30 seconds.',
      disclaimer1: "This isn't therapy. It isn't professional advice.",
      disclaimer2: "It's something better for this specific moment.",
      disclaimer3:
        "It's a tool for instant clarity when your head can't process it alone anymore.",
      disclaimer4:
        "MyCodeEx doesn't tell you what to do with your life. It tells you what's behind that message. And with that info, you decide.",
    },
    testimonials: {
      h2Part1: 'What people',
      h2Italic: 'already using it',
      h2Part2Suffix: ' say',
      items: [
        {
          quote:
            'I spent two hours trying to figure out if he was mad or just busy. MyCodeEx told me in 20 seconds and the reply I chose worked.',
          author: 'Valeria M.',
          age: '24 years old',
        },
        {
          quote:
            "I felt ridiculous for not being able to interpret a three-line message. Now I get it — it wasn't me. I just needed the right tools.",
          author: 'Andrea R.',
          age: '29 years old',
        },
        {
          quote:
            'I used it on a message from my boss that had me on edge since Monday. Total clarity. I replied with confidence.',
          author: 'Carlos T.',
          age: '31 years old',
        },
      ],
    },
    pricing: {
      h2Part1: 'What you get with',
      h2Italic: 'MyCodeEx Pro',
      benefits: [
        {
          title: 'Unlimited analyses',
          desc: 'No limits when you need it most',
        },
        {
          title: 'Tone + intent + interest level',
          desc: 'Full clarity on every message',
        },
        {
          title: '3 ready replies per analysis',
          desc: "You'll never run out of what to say",
        },
        {
          title: 'Analysis history',
          desc: 'Review patterns from past conversations',
        },
        {
          title: 'Instant access from any device',
          desc: 'Available when the message lands',
        },
      ],
      priceTitle: 'The price',
      compare1Label: 'Couples therapy',
      compare1Price: '$150/hour',
      compare2Label: "Friends' advice",
      compare2Price: "free but useless when you're emotionally involved",
      compare3Label: 'MyCodeEx Pro',
      compare3Price: '$4.99/month',
      priceClosing:
        'Less than a cup of coffee. For unlimited clarity in every conversation that matters.',
      noRiskTitle: 'No risk. No commitment.',
      noRisk1:
        'Start with 3 completely free analyses. No credit card. No tricks.',
      noRisk2:
        "If after using it you don't feel it changes the way you read your conversations, just don't subscribe.",
      noRisk3:
        'But if what you feel is what thousands of users feel every week — that "finally I understand what\'s happening" feeling — then $4.99/month will be the easiest decision you make today.',
      finalTitle: 'One last thing before you close this page',
      final1: 'That message is still there.',
      final2:
        "And the more time you spend without understanding what's really behind it, the more time you spend making decisions blind.",
      final3: 'The clarity you need is 30 seconds away.',
      finalItalic: 'Paste the message. Read the code. Reply with certainty.',
      finalCta: '▶ START FREE NOW — 3 ANALYSES AT NO COST',
      finalDisclaimer: 'No credit card. Instant access. Cancel anytime.',
    },
    faq: {
      title: 'Frequently Asked Questions',
      items: [
        {
          q: 'Is it accurate?',
          a: "MyCodeEx analyzes language and tone patterns. It doesn't guess — it decodes. The results are as useful as the context you give it.",
        },
        {
          q: 'Is this therapy or professional advice?',
          a: 'No. MyCodeEx is an entertainment and text interpretation tool. For situations that require professional support, we always recommend seeing a specialist.',
        },
        {
          q: 'What happens if I cancel?',
          a: 'You can cancel anytime, no penalties, from your profile in seconds.',
        },
        {
          q: 'Is it safe to paste my conversations?',
          a: "MyCodeEx doesn't store or share your messages with third parties. Your privacy is a priority.",
        },
        {
          q: 'What kind of messages does it work for?',
          a: "Relationships, work, friends, family — any text message where the tone or intent isn't clear.",
        },
      ],
    },
    footer: {
      copyright: 'All rights reserved.',
      tagline: 'A tool for instant clarity.',
      privacy: 'Privacy Policy',
      terms: 'Terms & Rights',
    },
    privacyModal: {
      title: 'Privacy Policy',
      lastUpdated: 'Last updated:',
      intro:
        'At MyCodeEx your privacy is a priority. This policy explains what information we collect, how we use it, and what control you have over it.',
      sections: [
        {
          h: '1. What we collect',
          p: 'We only collect the minimum information needed for the app to work: your email when you create an account, and the messages you choose to paste for analysis. We do not access your conversations, contacts, or social media.',
        },
        {
          h: '2. What we do with your messages',
          p: 'The messages you paste are processed solely to deliver your analysis. We do not store or share your messages with third parties for commercial purposes. The analysis history is visible only to you, in your account, and you can delete it at any time.',
        },
        {
          h: '3. Cookies and analytics',
          p: 'We use essential cookies to keep your session and anonymized analytics tools to understand how the app is used. We never sell your data.',
        },
        {
          h: '4. Your rights',
          p: 'You can access, correct, or delete your information whenever you want by writing to privacy@mycodeex.app. You can also cancel your account in seconds from your profile.',
        },
        {
          h: '5. Changes to this policy',
          p: "If we update this policy, we'll notify you by email or inside the app before the changes take effect.",
        },
      ],
    },
    termsModal: {
      title: 'Terms & Rights',
      lastUpdated: 'Last updated:',
      intro:
        "By using MyCodeEx you accept the following terms. We recommend reading them carefully — they're written to be understood.",
      sections: [
        {
          h: '1. What MyCodeEx is',
          p: "MyCodeEx is an entertainment and text interpretation tool. It is not therapy, not legal or professional advice, and does not replace a specialist's judgment when a situation requires one.",
        },
        {
          h: '2. Responsible use',
          p: 'You agree to use the app for your own messages or messages legitimately shared with you. Do not use MyCodeEx to harass, spy on, or manipulate other people.',
        },
        {
          h: '3. Subscription and payments',
          p: 'MyCodeEx Pro costs $4.99/month. You can cancel anytime from your profile; access continues until the end of the period already paid. The first 3 analyses are free and require no card.',
        },
        {
          h: '4. Intellectual property',
          p: 'The name MyCodeEx, the logo, the Emotional Code Reading™ mechanism, the texts, the design, and the app code are property of MyCodeEx and are protected by copyright and trademark laws. They may not be copied or redistributed without written permission.',
        },
        {
          h: '5. Limitation of liability',
          p: 'Analyses are suggestions based on language patterns. The final decision on how to reply, what to do, or how to interpret a relationship is yours. MyCodeEx is not responsible for the results of the conversations or decisions you make.',
        },
        {
          h: '6. Contact',
          p: 'Questions, suggestions, or complaints? Write to hola@mycodeex.app. We respond within 48 hours.',
        },
      ],
    },
  },
} as const

export type Translations = typeof translations.es
